<template>
  <div class="page" id="page-login">
    <Metadata
      :title="this.title"
    />
    <div id="login">
      <div id="login-logo" />
      <form id="login-form">
        <input
          class="login-form-input"
          type="text"
          placeholder="Username"
          name="username"
          v-model="input.username"
        />
        <input
          class="login-form-input"
          type="password"
          placeholder="Password"
          name="password"
          v-model="input.password"
        />
        <button id="login-form-button" type="button" v-on:click="login()">Sign In</button>

        <!-- TODO: reinstate after stage 1 -->
        <!-- <router-link id="login-form-reset" to="/reset">Forgot Password</router-link> -->
      </form>
    </div>
    <Bottom />
  </div>
</template>

<script>

import Bottom from '../../components/nav/Bottom.vue';

export default {
  name: 'login',
  props: {
    error: String,
  },
  beforeMount() {
    if (this.$store.getters.hasUser) {
      this.$router.replace('/advertisers');
    }
    if (this.error) {
      this.$notify({
        group: 'notifications',
        title: 'Update',
        text: this.error,
        position: 'bottom right',
        duration: 5000,
        type: 'warn',
      });
    }
  },
  components: {
    Bottom,
  },
  data() {
    return {
      title: `reporting - login`,
      input: {
        username: '',
        password: '',
      },
    };
  },
  methods: {
    login() {
      this.$http.post('/api/users/check', this.input)
        .then((response) => {
          this.$store.commit('authenticate', response.body);
        })
        .then(() => {
          const user = this.$store.state.user;
          if (user.includes('publisher-')) {
            this.$router.push('/publishers');
          } else {
            this.$router.push('/advertisers');
          }
        })
        .catch(() => {
          this.input.username = '';
          this.input.password = '';
        });
    },
  },
};
</script>

<style>

/* specific page styling */

#page-login {
  background-color: #fff;
}

/* main login container */
#login {
  top: 18%;
}
  /* login circular logo */
#login-logo {
  background-image: url('~@/assets/logo/adelaide-logotype-purple.svg');
  background-size: 100% auto;
  background-position: center;
  background-repeat:no-repeat;
  margin: 0 auto;
  width: 258px;
  height: 52px;
}

/* main login form */
#login-form {
  width: 300px;
  margin: 60px auto 0 auto;
  text-align: center;
}

/* username and password input fields */
.login-form-input {
  background: #ffffff;
  width: 100%;
  height: 38px;
  border: 1px solid #cccccc;
  margin: 0 0 12px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 18px;
  border-radius: 5px;
  color: #222;
}

.login-form-input::placeholder {
  color: #ccc;
}

.login-form-input::-ms-input-placeholder { /* Internet Explorer 10-11 */
 color: #ccc;
}

.login-form-input::-ms-input-placeholder { /* Microsoft Edge */
 color: #ccc;
}

.login-form-input:focus,
.login-form-input:active {
  outline-color: #c70039;
}

#login-form-button {
  text-transform: uppercase;
  margin: 8px auto 0px auto;
  background: #4c123e;
  width: 100%;
  border: 0;
  padding: 9px;
  color: #FFFFFF;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
  border-radius: 5px;
  transition: 0.2s all ease;
}

#login-form-button:hover,
#login-form-button:active {
  background-color: #900c3e;
}

#login-form-reset {
  display: inline-block;
  margin: 11px;
  font-weight: 600;
  font-size: 14px;
  transition: 0.2s all ease;
}

#login-form-reset:hover {
  color: #4c123e;
}

</style>
